import { z } from 'zod';

export const PASSWORD_MIN = 12;
export const PASSWORD_MAX = 200;

/** Mirrors the backend's 12 to 200 characters; the confirmation exists only on the client. */
export const resetPasswordSchema = z
  .object({
    password: z
      .string()
      .min(PASSWORD_MIN, { error: 'auth:validation.passwordMin' })
      .max(PASSWORD_MAX, { error: 'auth:validation.passwordMax' }),
    confirm: z.string(),
  })
  .refine((v) => v.password === v.confirm, {
    path: ['confirm'],
    error: 'auth:validation.passwordMismatch',
  });

export type ResetPasswordValues = z.infer<typeof resetPasswordSchema>;
